import { uniq } from 'es-toolkit';
import React from 'react';

import { getChildrenFinder, getComponentDesignDescendants } from '@paragon/layout-models';
import { OptionalTooltip } from '@paragon/material';

import { useAppMonitor } from '../../../../monitor';
import { bulkUpgradeAndAnalyze } from '../../../../store/actions/paragonProcessActions';
import { areWorkingChangesByComponentDesignGuidMap } from '../../../../store/selectors/workingChangesSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { UpgradeAndAnalyzeIcon } from '../../icons/UpgradeAndAnalyzeIcon';
import { SceneMenuItem } from '../common/SceneMenuItem';

interface Props {
  readonly type: string;
  readonly modelGuid: string;
}

export function AnalyzeAllChangedMenuItem({ type, modelGuid }: Props) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const childrenFinder = useAppSelector(getChildrenFinder);
  const workingChangesByComponentDesignGuid = useAppSelector(areWorkingChangesByComponentDesignGuidMap);
  const componentDesignGuids = uniq(
    getComponentDesignDescendants(modelGuid, childrenFinder).map((design) => design.guid),
  ).filter((componentDesignGuid) => workingChangesByComponentDesignGuid[componentDesignGuid]);
  const areComponentsWithWorkingChanges = componentDesignGuids.length !== 0;

  return (
    <OptionalTooltip
      visible={!areComponentsWithWorkingChanges}
      title="No components have working changes"
      placement="right"
    >
      <SceneMenuItem
        icon={<UpgradeAndAnalyzeIcon />}
        text="Analyze All Changed Components"
        disabled={!areComponentsWithWorkingChanges}
        onClick={() => {
          dispatch(bulkUpgradeAndAnalyze(Array.from(componentDesignGuids)));
          monitor.recordInteraction('Analyze All Changed Components menu item clicked', { type });
        }}
      />
    </OptionalTooltip>
  );
}
